export default __webpack_public_path__ + "static/media/high-five.23934608.png";